import React, { useState, useEffect } from 'react'
import styles from './styles'
import {
  withStyles,
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
} from '@material-ui/core'
import UserType from 'src/model/user-types'
import { componentBoxHideAction } from 'src/reducers/component-box/action'
import { setUserRoleAction } from 'src/reducers/user-role-detailed-list/action'
import { getUserReportByIdService } from 'src/api/authentication'
import { CoreButton, CoreTextField } from 'src/components/core'

const UserRoleEdit = props => {
  const { dispatch, entity, classes } = props
  const [userRole, setUserRole] = useState(entity.roleType)
  const [loading, setLoading] = useState(false)
  const [totalActionsCount, setTotalActionsCount] = useState('')
  const [trialStartDate, setTrialStartDate] = useState('')
  const [uniqueEngagedUsers, setUniqueEngagedUsers] = useState('')
  /**
   *
   * @param {*} e
   */
  const handleCourse = e => {
    setUserRole(e.target.value)
  }

  useEffect(() => {
    setLoading(true)
    getUserReportByIdService(entity.id).then(response => {
      setTotalActionsCount(response.data.totalActionsCount)
      setTrialStartDate(response.data.trialStartDate)
      setUniqueEngagedUsers(response.data.uniqueEngagedUsers)
      setLoading(false)
    })
  }, [entity])
  const saveRole = () => {
    const data = {
      userName: entity.userName,
      email: entity.email,
      id: entity.id,
      roleType: userRole,
      shopId: entity.shopId,
    }
    dispatch(setUserRoleAction(data))
    dispatch(componentBoxHideAction())
  }
  return (
    <div className={classes.namingModalContent}>
      <div className={classes.modalItems}>
        <FormControl fullWidth={true} variant="outlined">
          <InputLabel id="demo-simple-select-helper-label">
            User Role
          </InputLabel>
          <Select
            fullWidth
            variant="outlined"
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            className={classes.select}
            inputProps={{
              className: classes.input,
            }}
            key={userRole}
            value={userRole}
            input={<Input id="select-input" name="select-input" />}
            onChange={handleCourse}
          >
            <MenuItem value={userRole} disabled>
              {UserType.getDisplayRoleName(userRole)}
            </MenuItem>
            {Object.keys(UserType).map(key => {
              if (!/^\d+$/.test(key)) return null
              return (
                <MenuItem value={key} key={key}>
                  {UserType.getDisplayRoleName(key)}
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
        <CoreTextField
          disabled={true}
          defaultValue={entity.email}
          label="Email"
        ></CoreTextField>
        <CoreTextField
          disabled={true}
          defaultValue={entity.name}
          label="Name"
        ></CoreTextField>
        <CoreTextField
          disabled={true}
          defaultValue={entity.surname}
          label="SurName"
        ></CoreTextField>
        <CoreTextField
          disabled={true}
          defaultValue={entity.id}
          label="ID"
        ></CoreTextField>
        <CoreTextField
          disabled={true}
          defaultValue={entity.userName}
          label="User Name"
        ></CoreTextField>
        {!loading && (
          <>
            <CoreTextField
              disabled={true}
              value={totalActionsCount}
              label="Total Action Count"
            >
              {totalActionsCount}
            </CoreTextField>
            <CoreTextField
              disabled={true}
              value={trialStartDate}
              label="Trial Start Date"
            >
              {trialStartDate}
            </CoreTextField>
            <CoreTextField
              disabled={true}
              value={uniqueEngagedUsers}
              label="Unique Engaged Users"
            >
              {uniqueEngagedUsers}
            </CoreTextField>
          </>
        )}

        <CoreButton
          variant="contained"
          color="success"
          onClick={() => saveRole()}
        >
          Save
        </CoreButton>
      </div>
    </div>
  )
}

export default withStyles(styles)(UserRoleEdit)
